import { takeEvery, fork, put, all } from 'redux-saga/effects';
// redux actions
import {
	GET_TARIFF,
	GET_TARIFFS_FOR_PORTFOLIO,
	TARIFF_RESET_ALL,
	TARIFF_CLEAR_ERROR,
} from './actionTypes';
import {
	setTariff,
	setTariffs,
	tariffError,
	tariffResetAll,
	tariffClearError,
} from './actions';
// Api methods
import { api } from 'api';
// interface
import { AxiosResponse } from 'axios';
import { Tariff, ProductSegment } from 'api';

export interface ITariffPayload {
	payload?: string | number;
	tariffSegment: ProductSegment;
	type: string;
}

function* getTariff({ payload }: ITariffPayload) {
	try {
		const response: AxiosResponse<Tariff> =
			yield api.tariff.apiTariffDataGetIdGet(Number(payload));

		yield put(setTariff(response.data));
	} catch (error: any) {
		yield put(tariffError(error.message));
	}
}

// function* getTariffs() {
//     try {
//         const response:AxiosResponse<Tariff[]> = yield api.tariff.api();
//         console.log("SAGA|getTariffs", response.data)
//         yield put(setTariffs(response.data));
//     } catch (error:any) {
//         console.log("SAGA|getTariffs|error",error)
//         yield put(tariffError(error.message));
//     }
// }

function* getTariffsForPortfolio({ payload, tariffSegment }: ITariffPayload) {
	// IOffer
	try {
		const response: AxiosResponse<Tariff[]> =
			yield api.tariff.apiTariffDataGetPortfolioTariffsIdGet(
				Number(payload)
			);
		if (tariffSegment === ProductSegment.Sme) {
			yield put(setTariffs(response.data));
		}
	} catch (error: any) {
		yield put(tariffError(error.message));
	}
}

function* clearError() {
	yield put(tariffClearError());
}

function* resetTariffStore() {
	yield put(tariffResetAll());
}

export function* watchGetTariff() {
	yield takeEvery(GET_TARIFF, getTariff);
}

// export function* watchGetTariffs() {
//     yield takeEvery(GET_TARIFFS, getTariffs);
// }

export function* watchGetTariffsForPortfolio() {
	yield takeEvery(GET_TARIFFS_FOR_PORTFOLIO, getTariffsForPortfolio);
}

export function* watchResetTariffStore() {
	yield takeEvery(TARIFF_RESET_ALL, resetTariffStore);
}

export function* watchClearError() {
	yield takeEvery(TARIFF_CLEAR_ERROR, clearError);
}

function* tariffSaga() {
	yield all([
		fork(watchGetTariff),
		// fork(watchGetTariffs),
		fork(watchGetTariffsForPortfolio),
		fork(watchResetTariffStore),
		fork(watchClearError),
	]);
}

export default tariffSaga;
